module.exports = __webpack_public_path__ + "img/spaceman-banner.a70dceac.jpg";